import {
  REPORTBRANCHREVENUE_UPDATE_FILTER,
  REPORTBRANCHREVENUE_COUNT_ASSIGN_SUCCESS,
  REPORTBRANCHREVENUE_HISTORY_LIST_SUCCESS,
  REPORTBRANCHREVENUE_IMPORT_SUCCESS,
  REPORTBRANCHREVENUE_LIST_SUCCESS,
  REPORTBRANCHREVENUE_NEW_CARE_SUCCESS,
} from 'src/actions/reportbranchrevenue.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';
import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';
import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  tongDoanhThuTamTinh: 0,
  tongDoanhThuTamTinhThucTe: 0,
  tongGoi: 0,
}

const reportbranchrevenueReducer = (state = initState, action) => {
  switch (action.type) {
    case REPORTBRANCHREVENUE_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case REPORTBRANCHREVENUE_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
        tongDoanhThuTamTinh: action.data.tongDoanhThuTamTinh,
        tongDoanhThuThucTe: action.data.tongDoanhThuThucTe,
        tongHoanTien: action.data.tongHoanTien,
        tongGoi: action.data.tongGoi,
      }
    }
    case REPORTBRANCHREVENUE_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case REPORTBRANCHREVENUE_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case REPORTBRANCHREVENUE_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case REPORTBRANCHREVENUE_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default reportbranchrevenueReducer